const SectionIconCell = ({ icon }) => {
  return (
    <div className="hidden sm:table-cell">
      <img src={icon} alt="Icon" width={24} height={24} />
    </div>
  );
};

export default SectionIconCell;
